import neetrepeaterhindibanner from '../../assets/neetrepeaterhindibanner.png'
export const banner_title=[
    {
        head_title: "नीट 2025 रिपीटर कोर्सेज",
        sub_head_title:"90%* तक कुल स्कॉलरशिप पाएं",
        type:"ऑनलाइन इंस्टेंट एडमिशन व स्कॉलरशिप टेस्ट",
        registration:"रजिस्ट्रेशन प्रारंभ",
        imagebanner: neetrepeaterhindibanner
    }
]

export const testcriteria = [
    {
        mainheading: 'परीक्षा विवरण',
        content: [
            {
                headings: [
                    { mode: 'ऑनलाइन मोड', details: 'बेहतर अनुभव के लिए डेस्कटॉप से जुड़ें', imgicon:'https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/online-icon1.svg' },
                    { mode: 'सुबह 9 बजे से रात 10 बजे तक', details: 'सभी दिन उपलब्ध (सोमवार से रविवार)', imgicon:'https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/watch-icon3.svg' },
                    { mode: '60 मिनट की अवधि', details: 'परीक्षण जमा करने के लिए', imgicon:'https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/time-icon2.svg' },
                ]
            }
        ]
    },
    {
        mainheading: 'कौन दे सकता है यह परीक्षा?',
        content: [
            {
                headings: [
                    { mode: 'कक्षा 12वीं में पढ़ रहे विद्यार्थी', details: 'जो छात्र कक्षा 12वीं में पढ़ रहे हैं, वे भी पात्र हैं', imgicon:'https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/eight-iocn-4.svg' },
                    { mode: 'कक्षा 12वीं में पढ़ रहे एवं  12वींपास विद्यार्थी', details: 'जो छात्र कक्षा 12वीं पास कर चुके हैं, वे भी पात्र हैं', imgicon:'https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/eight-iocn-4.svg' },
                ]
            }
        ]
    }
];
export const scholarships = [
    {
        targetId: '1',
        heading: 'iACST क्या है और यह क्या प्रदान करता है?',
        subheading: 'iACST का मतलब इंस्टेंट एडमिशन कम स्कॉलरशिप टेस्ट है। यह एक ऑनलाइन स्कॉलरशिप परीक्षा है जो विद्यार्थियों को NEET कोर्सेस पर इंस्टेंट स्कॉलरशिप प्रदान करती है।',
        bulletpoints: [
        ],
    },  
    {
        targetId: '2',
        heading: 'iACST देने के लिए कौन पात्र है?',
        subheading: 'कक्षा 12वीं और कक्षा 12वीं पास विद्यार्थी iACST दे सकते हैं।',
        bulletpoints: [
        ],
    },  
    {
        targetId: '3',
        heading: 'iACST के लिए कोई शुल्क है क्या?',
        subheading: 'iACST पूरी तरह से निःशुल्क है। आप iACST के लिए ऑनलाइन रजिस्टर कर सकते हैं और परीक्षा के लिए अपनी पसंद की तारीख और समय स्लॉट चुन सकते हैं।',
        bulletpoints: [
        ],
    },  
    {
        targetId: '4',
        heading: 'iACST देने के क्या फायदे हैं?',
        subheading: 'iACST में अच्छा प्रदर्शन करके, विद्यार्थी NEET कोर्सेस पर इंस्टेंट स्कॉलरशिप प्राप्त कर सकते हैं।',
        bulletpoints: [
        ],
    }, 
    {
        targetId: '5',
        heading: 'iACST परीक्षा कब दी जा सकती है?',
        subheading: 'iACST प्रतिदिन आयोजित की जाती है, और आप अपनी सुविधा के अनुसार सुबह 9:00 बजे से रात 10:00 बजे तक किसी भी समय स्लॉट का चयन कर सकते हैं।',
        bulletpoints: [
        ],
    }, 
    {
        targetId: '6',
        heading: 'iACST ऑनलाइन देने के लिए क्या आवश्यकताएं हैं?',
        subheading: 'हम iACST को डेस्कटॉप या लैपटॉप पर देने की सलाह देते हैं। आपको एक स्थिर इंटरनेट कनेक्शन और टेस्ट पोर्टल तक पहुंचने के लिए एक ब्राउज़र की आवश्यकता होगी।',
        bulletpoints: [
        ],
    },  
    {
        targetId: '7',
        heading: 'अगर टेस्ट के दौरान तकनीकी समस्या हो तो क्या करें?',
        subheading: 'तकनीकी समस्याओं की स्थिति में, आप iACST हेल्पलाइन 18001022727 पर कॉल या <a href= "mailto:acstsupport@aesl.in">acstsupport@aesl.in</a> पर ईमेल या यह फॉर्म भर कर सकते हैं: <a href="https://forms.gle/g9skRtHYSaTxexPL9" target="_blank">https://forms.gle/g9skRtHYSaTxexPL9</a> ',
        bulletpoints: [
        ],
    },  
]









